import React, { useEffect, useRef, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { InputMask } from '@react-input/mask';
import config from "../coreFIles/config";
import JoditEditor from "jodit-react";
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDropzone } from "react-dropzone";

import { getCategoriesAction, getnavChildCategoriesAction, getSearchSuburbAction, getPlansAction, getPlanDetailsAction, createAdAction, createAdPlanPaymentIntentAction, createAdWithPaymentAction, createAdFeePaymentIntentAction, getglobalSettingsListAction, getMemberDetailsAction, getUserFreeAdCountAction } from '../Action/action';

const getDomainId = () => {
	try {
		const cookieData = Cookies.get('domain_id');
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error('Error parsing domain_id cookie:', error);
		return [];
	}
};

const Domainid = getDomainId();
const AddAd = () => {
	const MAX_FILES = 5;
	const [files, setFiles] = useState([]);

	const onDrop = (acceptedFiles) => {
		setFiles((prevFiles) => {
			const newFiles = acceptedFiles.map((file) =>
				Object.assign(file, { preview: URL.createObjectURL(file) })
			);
			const combined = [...prevFiles, ...newFiles].slice(0, MAX_FILES);
			return combined;
		});
	};

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		accept: { 'image/*': [] },
		multiple: true,
		maxFiles: MAX_FILES,
	});

	const removeFile = (index) => {
		setFiles((prevFiles) => {
			const updated = [...prevFiles];
			const removed = updated.splice(index, 1)[0];
			if (removed && removed.preview) {
				URL.revokeObjectURL(removed.preview);
			}
			return updated;
		});
	};

	const filesRef = useRef(files);
	useEffect(() => {
		filesRef.current = files;
		setForm((old) => ({ ...old, images: files }));
	}, [files]);

	useEffect(() => {
		return () => {
			filesRef.current.forEach((file) => {
				if (file && file.preview) {
					URL.revokeObjectURL(file.preview);
				}
			});
		};
	}, []);
	
	// Style state for reactive styling
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			const storedStyle = Cookies.get('domainstyle');
			if (storedStyle) {
				try {
					setStyle(JSON.parse(storedStyle));
				} catch (error) {
					console.error('Error parsing style cookie:', error);
					setStyle([]);
				}
			} else {
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');

	if (!Cookies.get('loginSuccessMember')) {
		window.location.href = `${config.baseUrl}`;
	}

	const editorHeight = '500px';
	const [spinloader, setspinloader] = useState(0);
	const getLoginData = () => {
		try {
			const cookieData = Cookies.get('loginSuccessMember');
			return cookieData ? JSON.parse(cookieData) : [];
		} catch (error) {
			console.error('Error parsing loginSuccessMember cookie:', error);
			return [];
		}
	};
	const loginData = getLoginData();
	const [categoriesList, setCategoriesList] = useState({});
	const [plansList, setPlansList] = useState({});
	const [childcatsList, setchildCats] = useState([]);
	const [allcatChilds, setallcatChilds] = useState([]);
	const [SuburbsearchResults, setSuburbsearchResults] = useState({});
	const [suburb, setsuburb] = useState('');
	const [validatioError, setvalidatioError] = useState({});
	const [currentDate, steCurrentDate] = useState(new Date());
	const [selectedOption, setSelectedOption] = useState(0);
	const [stripe, setStripe] = useState(null);
	const [cardElement, setCardElement] = useState(null);
	const [paymentProcessing, setPaymentProcessing] = useState(false);
	const [showPaymentSection, setShowPaymentSection] = useState(false);
	const [settings, setSettings] = useState({});
	const [isVIP, setIsVIP] = useState(false);
	const [adFeeAmount, setAdFeeAmount] = useState(0);
	const [adFeeType, setAdFeeType] = useState(''); // 'free_ad_fee' or 'personal_ad_fee'
	const [requiresAdFeePayment, setRequiresAdFeePayment] = useState(false);
	const [userFreeAdCount, setUserFreeAdCount] = useState(0);


	const [form, setForm] = useState({
		parent_id: '',
		category_id: '',
		title: '',
		description: '',
		suburb: '',
		age_group: '',
		area: '',
		gender: '',
		images: {},
		phone: '',
		yt_video_url: '',
		tags: '',
		hide_my_id: 0,
		status: 1,
		plan_id: 0,
		whatson_date: '',
		event_type: '',
		price: '',
		property_type: '',
		bedrooms: '',
		unit_flat: '',
		street_no: '',
		street_name: '',
		work_type: '',
		abn: '',
		accreditation: '',
		from_date: '',
		to_date: '',
		planDays: '',
		planAmount: '',
		member_id: loginData?.id,
		ad_domain: Domainid ? Domainid.domain_id : 0
	});
	useEffect(() => {
		getCategories();
		getCategoriesChilds();
		getPlans();
		getSettings();
		loadStripe();
		checkVIPStatus(); // This is now async, but useEffect can handle it
		getUserFreeAdCount(); // Fetch user's free ad count
	}, [])

	// Check if user is VIP
	const checkVIPStatus = async () => {
		try {
			if (loginData && loginData.id) {
				let res = await getMemberDetailsAction({ id: loginData.id });
				if (res.success && res.data) {
					// Check if membership_type is 2 (VIP)
					const membershipType = res.data.membership_type;
					if (membershipType == 2 || membershipType === '2') {
						setIsVIP(true);
					} else {
						setIsVIP(false);
					}
				} else {
					setIsVIP(false);
				}
			} else {
				setIsVIP(false);
			}
		} catch (error) {
			setIsVIP(false);
		}
	}

	// Get settings
	const getSettings = async () => {
		try {
			let res = await getglobalSettingsListAction({ domain_id: Domainid?.domain_id });
			if (res.success) {
				setSettings(res.data);
			}
		} catch (error) {
			// Error fetching settings
		}
	}

	// Get user's free ad count
	const getUserFreeAdCount = async () => {
		try {
			if (loginData && loginData.id) {
				let res = await getUserFreeAdCountAction({ member_id: loginData.id });
				if (res.success && res.data) {
					setUserFreeAdCount(parseInt(res.data.total) || 0);
				}
			}
		} catch (error) {
			setUserFreeAdCount(0);
		}
	}

	// Check if ad fee payment is required
	useEffect(() => {
		checkAdFeeRequirement();
	}, [form.parent_id, form.plan_id, settings, isVIP, userFreeAdCount])

	const checkAdFeeRequirement = () => {
		// Only check ad fee requirement when plan_id = 0 (free plan)
		// If premium plan is selected (plan_id > 0), skip ad fee check
		if (form.plan_id > 0) {
			setRequiresAdFeePayment(false);
			setAdFeeAmount(0);
			setAdFeeType('');
			return;
		}

		if (!settings || Object.keys(settings).length === 0) {
			setRequiresAdFeePayment(false);
			return;
		}

		// Ensure parent_id is set
		if (!form.parent_id || form.parent_id === '') {
			setRequiresAdFeePayment(false);
			return;
		}

		const parentId = parseInt(form.parent_id) || 0;
		const isPersonalsCategory = (parentId === parseInt(config.cat_per)); // cat_per = 1

		// VIP Member logic (only for plan_id = 0)
		if (isVIP) {
			// VIP can post non-personal ads for free (always, regardless of settings)
			if (!isPersonalsCategory) {
				setRequiresAdFeePayment(false);
				setAdFeeAmount(0);
				setAdFeeType('');
				return;
			}
			// VIP posting personal ad - check if free ads allowed
			if (isPersonalsCategory && (settings.allow_personal_free_ads == 0 || settings.allow_personal_free_ads === '0')) {
				setRequiresAdFeePayment(true);
				setAdFeeAmount(parseFloat(settings.personal_ad_fee) || 0);
				setAdFeeType('personal_ad_fee');
				return;
			}
			// VIP posting personal ad and free ads allowed
			setRequiresAdFeePayment(false);
			setAdFeeAmount(0);
			setAdFeeType('');
			return;
		}

		// Non-VIP Member logic (only for plan_id = 0)
		if (isPersonalsCategory) {
			// Personal ad - check if free ads allowed
			if (settings.allow_personal_free_ads == 0 || settings.allow_personal_free_ads === '0') {
				setRequiresAdFeePayment(true);
				setAdFeeAmount(parseFloat(settings.personal_ad_fee) || 0);
				setAdFeeType('personal_ad_fee');
				return;
			}
		} else {
			// Non-personal ad - check if free ads allowed
			// Non-VIP users must pay if allow_basic_free_ads = 0
			if (settings.allow_basic_free_ads == 0 || settings.allow_basic_free_ads === '0') {
				setRequiresAdFeePayment(true);
				setAdFeeAmount(parseFloat(settings.free_ad_fee) || 0);
				setAdFeeType('free_ad_fee');
				return;
			}
			// If allow_basic_free_ads = 1, check if user has exceeded free ad limit
			if (settings.allow_basic_free_ads == 1 || settings.allow_basic_free_ads === '1') {
				const freeAdLimit = parseInt(settings.non_vip_free_ad_count) || 0;
				// If limit is 0, always require payment (no free ads allowed)
				if (freeAdLimit === 0) {
					setRequiresAdFeePayment(true);
					setAdFeeAmount(parseFloat(settings.free_ad_fee) || 0);
					setAdFeeType('free_ad_fee');
					return;
				}
				// If user has posted free ads >= limit, require payment
				if (userFreeAdCount >= freeAdLimit) {
					setRequiresAdFeePayment(true);
					setAdFeeAmount(parseFloat(settings.free_ad_fee) || 0);
					setAdFeeType('free_ad_fee');
					return;
				}
			}
		}
		setRequiresAdFeePayment(false);
		setAdFeeAmount(0);
		setAdFeeType('');
	}

	// Load Stripe.js
	const loadStripe = () => {
		if (window.Stripe) {
			setStripe(window.Stripe(config.stripePublishableKey));
		} else {
			const script = document.createElement('script');
			script.src = 'https://js.stripe.com/v3/';
			script.async = true;
			script.onload = () => {
				setStripe(window.Stripe(config.stripePublishableKey));
			};
			document.body.appendChild(script);
		}
	}

	// Initialize Stripe Elements when premium plan is selected or ad fee payment required
	useEffect(() => {
		if (stripe && ((selectedOption > 0 && showPaymentSection) || (requiresAdFeePayment && showPaymentSection))) {
			const elements = stripe.elements();
			const card = elements.create('card', {
				style: {
					base: {
						fontSize: '16px',
						color: '#424770',
						'::placeholder': {
							color: '#aab7c4',
						},
					},
					invalid: {
						color: '#9e2146',
					},
				},
			});
			
			const cardElementDiv = document.getElementById('ad-card-element');
			if (cardElementDiv) {
				card.mount('#ad-card-element');
				setCardElement(card);

				card.on('change', ({error}) => {
					const displayError = document.getElementById('ad-card-errors');
					if (error) {
						displayError.textContent = error.message;
					} else {
						displayError.textContent = '';
					}
				});
			}

			return () => {
				if (card) {
					card.unmount();
				}
			};
		}
	}, [stripe, selectedOption, showPaymentSection, requiresAdFeePayment])

	const getCategories = async (e) => {
		let res = await getCategoriesAction();
		if (res.success) {
			setCategoriesList(res.data)
		}
	}

	const getCategoriesChilds = async () => {
		let res = await getnavChildCategoriesAction();
		if (res.success) {
			setallcatChilds(res.data);
		}
	};

	const getPlans = async (e) => {
		let res = await getPlansAction();
		if (res.success) {
			setPlansList(res.data)
		}
	}

	const SearchSuburb = async (str) => {
		try {
			setsuburb(str);
			if (str != '') {
				let res = await getSearchSuburbAction({ str: str });
				setSuburbsearchResults(res.data);

				setForm((old) => {
					return { ...old, 'suburb': str };
				});
			}
			else {
				setSuburbsearchResults('');
			}
		}
		catch (error) {
			console.error(error);
		}
	};

	const handleSelectSuburb = (row) => {
		setsuburb(row);

		setForm((old) => {
			return { ...old, 'suburb': row };
		});

		setSuburbsearchResults({});
	};

	const inputHandler = async (e) => {
		const { name, value } = e.target
		setForm((old) => {
			return { ...old, [name]: value }
		})
	}

	function formatDate(str) {
		var date = new Date(str),
			mnth = ("0" + (date.getMonth() + 1)).slice(-2),
			day = ("0" + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join("-");
	}

	function adddaysToDate(days) {
		var cdate = new Date();
		var result = cdate.setDate(cdate.getDate() + days);
		var newdate = formatDate(result);

		return newdate;
	}

	const whatsonDate = e => {
		let whtsonDate = formatDate(e);
		setForm((old) => {
			return { ...old, 'whatson_date': whtsonDate }
		})
	}

	const handleKeyPress = (e) => {
		// Allow only numeric values (0-9) and certain control keys
		const isValidInput = /^[0-9\b]+$/.test(e.key);

		if (!isValidInput) {
			e.preventDefault();
		}
	};

	const handleSelect = async (e) => {
		const { name, value } = e.target
		setForm((old) => {
			return { ...old, [name]: value }
		})
	}

	const checkboxHandler = (e) => {
		const { name, value } = e.target;
		if (e.target.checked) {
			setForm((old) => {
				return { ...old, [name]: value };
			});
		} else {
			setForm((old) => {
				return { ...old, [name]: 0 };
			});
		}
	};

	const descriptionHandler = async (e) => {
		setForm((old) => {
			return { ...old, 'description': e }
		})
	}

	const handleParentCat = async (id) => {
		if (parseInt(id) == parseInt(config.cat_per)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'price': '',
					'whatson_date': '',
					'event_type': '',
					'work_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_real)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'price': '',
					'whatson_date': '',
					'event_type': '',
					'work_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_buy)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'whatson_date': '',
					'event_type': '',
					'work_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_whats)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'price': '',
					'work_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_jobs)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'price': '',
					'whatson_date': '',
					'event_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_eat)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'price': '',
					'whatson_date': '',
					'event_type': '',
					'work_type': '',
					'abn': '',
					'accreditation': '',
				};
			});
		}
		else if (parseInt(id) == parseInt(config.cat_business)) {
			setForm((old) => {
				return {
					...old,
					'parent_id': id,
					'age_group': '',
					'gender': '',
					'property_type': '',
					'bedrooms': '',
					'unit_flat': '',
					'street_no': '',
					'street_name': '',
					'price': '',
					'whatson_date': '',
					'event_type': '',
					'work_type': '',
				};
			});
		}
		const result = allcatChilds.filter(data => String(data.parent_id).includes(id));
		if (result.length > 0) {
			setchildCats(result);
		}
		else {
			setchildCats({});
		}

	};

	const handleChange = async (e) => {
		setSelectedOption(e.target.value);
		if (e.target.value != 0) {
			let date = new Date();
			let fromDate = formatDate(date);
			let res = await getPlanDetailsAction({ id: e.target.value });
			if (res.success) {
				let toDate = adddaysToDate(res.data.days);

				setForm((old) => {
					return {
						...old,
						'from_date': fromDate,
						'to_date': toDate,
						'planDays': res.data.days,
						'planAmount': res.data.price,
						'plan_id': e.target.value
					}
				})
				setShowPaymentSection(true);
			} else {
				setForm((old) => {
					return {
						...old,
						'from_date': '',
						'planDays': '',
						'to_date': '',
						'planAmount': '',
						'plan_id': 0
					}
				})
				setShowPaymentSection(false);
			}
		} else {
			setForm((old) => {
				return {
					...old,
					'from_date': '',
					'planDays': '',
					'to_date': '',
					'planAmount': '',
					'plan_id': 0
				}
			})
			// Show payment section if ad fee payment is required
			if (requiresAdFeePayment) {
				setShowPaymentSection(true);
			} else {
				setShowPaymentSection(false);
			}
		}
	}

	// Show payment section when ad fee is required (only for plan_id = 0)
	useEffect(() => {
		if (form.plan_id > 0) {
			// Premium plan selected - payment section will be handled by handleChange
			return;
		}
		if (requiresAdFeePayment && adFeeAmount > 0) {
			setShowPaymentSection(true);
		} else if (!requiresAdFeePayment && form.plan_id == 0) {
			setShowPaymentSection(false);
		}
	}, [requiresAdFeePayment, adFeeAmount, form.plan_id])

	const inputPhoneHandler = async (e) => {
		const { name, value } = e.target

		setForm((old) => {
			return { ...old, [name]: value }
		})

	}
	const handleKeyDown = (e) => {
		if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
			e.preventDefault();
		}
	};

	function validate() {
		let parentError = "";
		let categoryError = "";
		let titleError = "";
		let descriptionError = "";
		let suburbError = "";
		let areaError = "";
		let statusError = "";

		if (form.parent_id === "") {
			parentError = "Category is required.";
		}

		if (form.category_id === "") {
			categoryError = "Sub Category is required.";
		}

		if (form.title === "") {
			titleError = "Ad title is required.";
		}

		if (form.description === "") {
			descriptionError = "Description is required.";
		}

		if (form.status === "") {
			statusError = "Status is required.";
		}

		if (form.suburb === "") {
			suburbError = "Suburb is required.";
		}

		if (form.area === "") {
			areaError = "Area is required.";
		}

		if (titleError || parentError || categoryError || descriptionError || statusError || suburbError || areaError) {
			setvalidatioError({
				titleError, parentError, categoryError, descriptionError, statusError, suburbError, areaError
			});
			return false;
		}
		else {
			setvalidatioError({
				titleError, parentError, categoryError, descriptionError, statusError, suburbError, areaError
			});
			return true;
		}
	}

	const processAdPayment = async () => {
		try {
			if (!stripe || !cardElement) {
				toast.error("Payment system not ready. Please refresh the page.");
				return;
			}

			setPaymentProcessing(true);

			// Step 1: Create payment intent
			const paymentIntentRes = await createAdPlanPaymentIntentAction({ 
				plan_id: form.plan_id,
				member_id: loginData?.id,
				email: loginData?.email 
			});
			
			if (!paymentIntentRes.success) {
				toast.error(paymentIntentRes.msg || "Failed to initialize payment");
				setPaymentProcessing(false);
				return;
			}

			// Step 2: Confirm payment with Stripe
			const { error: stripeError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
				paymentIntentRes.client_secret,
				{
					payment_method: {
						card: cardElement,
						billing_details: {
							name: `${loginData?.fname || ''} ${loginData?.lname || ''}`.trim() || loginData?.email,
							email: loginData?.email,
						},
					},
				}
			);

			if (stripeError) {
				toast.error(stripeError.message || "Payment failed");
				setPaymentProcessing(false);
				return;
			}

			if (confirmedPaymentIntent.status === 'succeeded') {
				// Step 3: Create ad with payment intent ID
				await SubmitFormWithPayment(confirmedPaymentIntent.id);
			} else {
				toast.error("Payment not completed");
				setPaymentProcessing(false);
			}
		} catch (error) {
			console.error('Payment Error:', error);
			toast.error("An error occurred during payment. Please try again.");
			setPaymentProcessing(false);
		}
	}

	const processAdFeePayment = async () => {
		try {
			if (!stripe || !cardElement) {
				toast.error("Payment system not ready. Please refresh the page.");
				return;
			}

			setPaymentProcessing(true);

			const parentId = parseInt(form.parent_id) || 0;
			const isPersonalsCategory = (parentId === parseInt(config.cat_per));

			// Step 1: Create payment intent for ad fee
			const paymentIntentRes = await createAdFeePaymentIntentAction({ 
				amount: adFeeAmount,
				fee_type: adFeeType,
				category_type: isPersonalsCategory ? 'personal' : 'basic',
				member_id: loginData?.id,
				email: loginData?.email 
			});
			
			if (!paymentIntentRes.success) {
				toast.error(paymentIntentRes.msg || "Failed to initialize payment");
				setPaymentProcessing(false);
				return;
			}

			// Step 2: Confirm payment with Stripe
			const { error: stripeError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
				paymentIntentRes.client_secret,
				{
					payment_method: {
						card: cardElement,
						billing_details: {
							name: `${loginData?.fname || ''} ${loginData?.lname || ''}`.trim() || loginData?.email,
							email: loginData?.email,
						},
					},
				}
			);

			if (stripeError) {
				toast.error(stripeError.message || "Payment failed");
				setPaymentProcessing(false);
				return;
			}

			if (confirmedPaymentIntent.status === 'succeeded') {
				// Step 3: Create ad with payment intent ID
				await SubmitFormWithAdFeePayment(confirmedPaymentIntent.id);
			} else {
				toast.error("Payment not completed");
				setPaymentProcessing(false);
			}
		} catch (error) {
			toast.error("An error occurred during payment. Please try again.");
			setPaymentProcessing(false);
		}
	}

	const SubmitFormWithPayment = async (paymentIntentId) => {
		const isValid = validate();
		if (!isValid) {
			setPaymentProcessing(false);
			return;
		}

		setspinloader(1);
		const formData = {
			...form,
			payment_intent_id: paymentIntentId
		};
		
		let res = await createAdWithPaymentAction(formData);
		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.href = `${config.baseUrl}manage-ads`;
			}, 2000);
		}
		else {
			setspinloader(0);
			setPaymentProcessing(false);
			toast.error(res.msg);
		}
	}

	const SubmitFormWithAdFeePayment = async (paymentIntentId) => {
		const isValid = validate();
		if (!isValid) {
			setPaymentProcessing(false);
			return;
		}

		setspinloader(1);
		const formData = {
			...form,
			payment_intent_id: paymentIntentId,
			ad_fee_type: adFeeType,
			ad_fee_amount: adFeeAmount,
			plan_id: 0 // Ensure it's treated as free ad with fee payment
		};
		
		let res = await createAdWithPaymentAction(formData);
		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.href = `${config.baseUrl}manage-ads`;
			}, 2000);
		}
		else {
			setspinloader(0);
			setPaymentProcessing(false);
			toast.error(res.msg);
		}
	}

	const SubmitForm = async (e) => {
		e.preventDefault()
		const isValid = validate();
		if (!isValid) {
			return;
		}

		// If premium plan selected, process payment first
		if (form.plan_id > 0) {
			await processAdPayment();
			return;
		}

		// If ad fee payment is required, process payment first
		if (requiresAdFeePayment && adFeeAmount > 0) {
			await processAdFeePayment();
			return;
		}

		// For free ads, proceed normally
		setspinloader(1);
		let res = await createAdAction(form);
		if (res.success) {
			toast.success(res.msg);
			setTimeout(() => {
				window.location.href = `${config.baseUrl}manage-ads`;
			}, 2000);
		}
		else {
			setspinloader(0);
			toast.error(res.msg);
		}
	}

	return (
		<>
			<Header />

			<div className="add-section mb-3">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Leftnav />
						</div>
						<div className="col-lg-6">
							<Toaster />

							<div className="classification-section">
								<h2 className="page-heading" style={{background:headerMenuColor}}> Post My Classified </h2>

								<form onSubmit={SubmitForm}>
									<div className="table-responsive table-striped ">
										<table className="table">
											<tbody>
												<tr>
													<th colSpan={plansList.length > 0 ? plansList.length-1 : 6} className="basicclassified text-center"  style={{background:headerMenuColor}}> BASIC CLASSIFIED</th>
													<th className="planInput darkbluebg text-center"  style={{background:headerMenuHoverColor}}>
														<span id="basicclassifieds"> </span>
														<input type="radio" value="0" checked={selectedOption == '0'}  onChange={handleChange} />
													</th>
												</tr>
												<tr>
													<td colSpan={plansList.length > 0 ? plansList.length : 7} className="planInfo text-center">(or) </td>
												</tr>
												<tr className="basicclassified lightbluebg">
													<td colSpan={plansList.length > 0 ? plansList.length : 7} className="planInfo text-center"  style={{background:headerMenuColor}}> PREMIUM CLASSIFIED </td>
												</tr>
												<tr>
													<td colSpan={plansList.length > 0 ? plansList.length : 7} className="planInfo"> With premium upgrade your listing will stand out. It will always be highlighted in the top section of your chosen category and also appear as featured classified on homepage. </td>
												</tr>
												<tr className="text-center lightbluebg" style={{background:headerMenuColor}}>
													{plansList.length > 0 ?
														plansList.map((row, index) => (
															<td key={index} className="plan">{row.days} Days<br />${row.price}</td>
														))
														: ''}
												</tr>
												<tr className="text-center darkbluebg" style={{background:headerMenuColor}}>
													{plansList.length > 0 ?
														plansList.map((row, index) => (
															<td key={index} className="planInput"><input className="required" type="radio" value={row.plan_id} checked={selectedOption == row.plan_id} onChange={handleChange} /></td>
														))
														: ''}
												</tr>
											</tbody>
										</table>
									</div>

									<div className="bondiclassified-fromsection">
										<div className="catagoryfrom">
											<div className="row">
												<div className="col-md-6 col-sm-12">
													<div className="form-group">
														<label for="parent_id">Category</label>
														<select className="form-control" id="parent_id" onChange={(e) => handleParentCat(e.target.value)}>
															<option value='0'>Select</option>
															{categoriesList.length > 0 ?
																categoriesList.map((row, index) => (
																	<option key={index} value={row.cat_id}>{row.cat_name}</option>
																))
																: ''}
														</select>
														<span className="text-danger">
															{validatioError.parentError}
														</span>
													</div>
												</div>

												<div className="col-md-6 col-sm-12">
													<div className="form-group">
														<label for="category_id">Sub Category</label>
														<select className="form-control" id="category_id" name="category_id" onChange={handleSelect}>
															<option>Select</option>
															{childcatsList.length > 0 ?
																childcatsList.map((row, index) => (
																	<option key={index} value={row.cat_id}>{row.cat_name}</option>
																))
																: ''}
														</select>
														<span className="text-danger">
															{validatioError.categoryError}
														</span>
													</div>
												</div>

												<div className="col-md-12 col-sm-12">
													<div className="form-group">
														<label for="title">Title</label>
														<input type="text" className="form-control" id="title" name='title' onChange={inputHandler} />
														<span className="text-danger">
															{validatioError.titleError}
														</span>
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group">
														<label for="desctiption">Description</label>
														&nbsp; <span className="text-danger">
															{validatioError.descriptionError}
														</span>
														<JoditEditor onChange={descriptionHandler} value='' name="description" id="description" style={{ height: editorHeight }} className="" placeholder="Enter description" />
													</div>
												</div>

												<div className="col-md-6">
													<div className="form-group">
														<label for="suburb">Suburb</label>
														<input type="text" name="suburb" className="form-control" id="suburb" onChange={(e) => SearchSuburb(e.target.value)} autoComplete="off" value={suburb} />

														<span className="text-danger">
															{validatioError.suburbError}
														</span>
														{SuburbsearchResults.length > 0 ? (
															<ul className="suburbList">
																{SuburbsearchResults.map((row) => (
																	<li key={row.id} onClick={() => handleSelectSuburb(row.rowlocation)}>
																		{row.rowlocation}
																	</li>
																))}
															</ul>
														) : null}
													</div>
												</div>

												<div className="col-md-6">
													<div className="form-group">
														<label for="area">Area</label>

														<select name='area' className="form-control" id='areaError' onChange={handleSelect}>
															<option value="">Select</option>
															<option value="Australia Wide">Australia Wide</option>
															<option value="NSW - Sydney">NSW - Sydney</option>
															<option value="NSW - Regional">NSW - Regional</option>
															<option value="QLD - Brisbane">QLD - Brisbane</option>
															<option value="QLD - Regional">QLD - Regional</option>
															<option value="VIC - Melbourne">VIC - Melbourne</option>
															<option value="VIC - Regional">VIC - Regional</option>
															<option value="WA - Perth">WA - Perth</option>
															<option value="WA - Regional">WA - Regional</option>
															<option value="SA - Adelaide">SA - Adelaide</option>
															<option value="SA - Regional">SA - Regional</option>
															<option value="NT - Darwin">NT - Darwin</option>
															<option value="NT - Regional">NT - Regional</option>
															<option value="TAS - Hobart">TAS - Hobart</option>
															<option value="TAS - Regional">TAS - Regional</option>
														</select>

														<span className="text-danger">
															{validatioError.areaError}
														</span>
													</div>
												</div>
											</div>
										</div>

										<div className="catagory-attchment">
											<div className="col-md-12">
												<div className="form-group">
													<label htmlFor="ad_image">Drag & Drop your images here OR simply click the "Select Files" button to upload.</label>
													<div
														{...getRootProps()}
														className="dropzone-area"
														style={{
															border: '2px dashed #cccccc',
															borderRadius: '6px',
															padding: '30px 20px',
															textAlign: 'center',
															cursor: 'pointer',
															backgroundColor: isDragActive ? '#f0f8ff' : '#fafafa',
															transition: 'background-color 0.2s ease-in-out'
														}}
													>
														<input {...getInputProps()} name="ad_image" />
														{isDragActive ? (
															<p style={{ margin: 0 }}>Drop the images here ...</p>
														) : (
															<p style={{ margin: 0 }}>
																Drag & Drop your file or <span style={{ textDecoration: 'underline' }}>Browse</span>
															</p>
														)}
														<small style={{ display: 'block', marginTop: '8px', color: '#666' }}>
															You can upload up to {MAX_FILES} images.
														</small>
													</div>

													{files.length > 0 && (
														<div className="dropzone-preview" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '15px' }}>
															{files.map((file, index) => (
																<div
																	key={`${file.name}-${index}`}
																	style={{
																		position: 'relative',
																		width: '100px',
																		height: '100px',
																		border: '1px solid #ddd',
																		borderRadius: '4px',
																		overflow: 'hidden',
																		background: '#fff'
																	}}
																>
																	<img
																		src={file.preview}
																		alt={file.name}
																		style={{ width: '100%', height: '100%', objectFit: 'cover' }}
																	/>
																	<button
																		type="button"
																		onClick={() => removeFile(index)}
																		style={{
																			position: 'absolute',
																			top: '2px',
																			right: '2px',
																			background: 'rgba(0,0,0,0.6)',
																			color: '#fff',
																			border: 'none',
																			borderRadius: '50%',
																			width: '22px',
																			height: '22px',
																			cursor: 'pointer',
																			lineHeight: '20px',
																			padding: 0
																		}}
																		aria-label="Remove image"
																	>
																		&times;
																	</button>
																</div>
															))}
														</div>
													)}
												</div>
											</div>
										</div>

										<div className="catagoryfrom">
											<div className="row">
												{parseInt(form?.parent_id) === parseInt(config.cat_per) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">
																	Age Group
																</label>

																<select name='age_group' className="form-control" id='age_groupError' onChange={handleSelect}>
																	<option value="">Select</option>
																	<option value="18-22">18-22</option>
																	<option value="23-26">23-26</option>
																	<option value="27-30">27-30</option>
																	<option value="31-36">31-36</option>
																	<option value="37-42">37-42</option>
																	<option value="43-50">43-50</option>
																	<option value="50-60">50-60</option>
																	<option value="over 61">over 61</option>
																</select>
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">
																	Gender
																</label>

																<select name='gender' className="form-control" id='genderError' onChange={handleSelect}>
																	<option value="">Select</option>
																	<option value="0">Male</option>
																	<option value="1">Female</option>
																</select>
															</div>
														</div>
													</>
													: ''}
												{parseInt(form?.parent_id) === parseInt(config.cat_real) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Property Type</label>

																<select name='property_type' className="form-control" id='property_typeError' onChange={handleSelect}>
																	<option value="">Select</option>
																	<option value="All">All</option>
																	<option value="Studio">Studio</option>
																	<option value="Apartment">Apartment</option>
																	<option selected="selected" value="House">House</option>
																	<option value="Rural">Rural</option>
																</select>
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Bedrooms</label>

																<select name='bedrooms' className="form-control" id='bedroomsError' onChange={handleSelect}>
																	<option value="">Select</option>
																	<option value="All">All</option>
																	<option value="1 or more">1 or more</option>
																	<option value="2 or more">2 or more</option>
																	<option value="3 or more">3 or more</option>
																	<option value="4 or more">4 or more</option>
																</select>
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Unit/Flat</label>

																<input type="text" name='unit_flat' className="form-control" id='unit_flatError' onChange={inputHandler} />
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Street No</label>

																<input type="text" name='street_no' className="form-control" id='street_noError' onChange={inputHandler} />
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Street Name</label>

																<input type="text" name='street_name' className="form-control" id='street_nameError' onChange={inputHandler} />
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Price</label>

																<input type="text" name='price' className="form-control" id='priceError' onChange={inputHandler} onKeyPress={handleKeyPress} />
															</div>
														</div>
													</>
													: ''}
												{parseInt(form?.parent_id) === parseInt(config.cat_buy) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Price</label>

																<input type="text" name='price' className="form-control" id='priceError' onChange={inputHandler} onKeyPress={handleKeyPress} />
															</div>
														</div>
													</>
													: ''}
												{parseInt(form?.parent_id) === parseInt(config.cat_whats) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">When is the Event?</label>

																<DatePicker onChange={whatsonDate} placeholder="Select Date" autoComplete="off" name="whatson_date" id="whatson_dateError" className='form-control' value={form.whatson_date} minDate={currentDate} />
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">
																	Day/Night Event?
																</label>

																<select name='event_type' className="form-control" id='event_typeError' onChange={handleSelect}>
																	<option value="">Select</option>
																	<option value="Day">Day</option>
																	<option value="Night">Night</option>
																</select>
															</div>
														</div>
													</>
													: ''}
												{parseInt(form?.parent_id) === parseInt(config.cat_jobs) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Work Type</label>

																<select name='work_type' className="form-control" id='work_typeError' onChange={handleSelect}>
																	<option value="">Select Work Type</option>
																	<option value="All">All</option>
																	<option value="Full Time">Full Time</option>
																	<option value="Part Time">Part Time</option>
																	<option value="Contract/Temp">Contract/Temp</option>
																	<option value="Freelance">Freelance</option>
																</select>
															</div>
														</div>
													</>
													: ''}
												{parseInt(form?.parent_id) === parseInt(config.cat_business) ?
													<>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">ABN (Australian Business Number)</label>
																<input className="form-control" type="text" name="abn" id='abnError' onChange={inputHandler} placeholder="Enter Australian Business Number" onKeyPress={handleKeyPress} />
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label className="">Accreditation</label>

																<input className="form-control" type="text" name="accreditation" id='accreditationError' onChange={inputHandler} placeholder="Enter Accreditation" />
															</div>
														</div>
													</>
													: ''}

												<div className="col-md-6 col-sm-6">
													<div className="form-group">
														<label for="phone">Phone</label>
														<InputMask
															type='text'
															className='form-control'
															name='phone'
															id='phone'
															value={form.phone}
															onChange={inputPhoneHandler}
															onKeyDown={handleKeyDown}
															mask="____ ___ ___"
															replacement={{ _: /\d/ }}
															placeholder="____ ___ ___"

														/>
													</div>
												</div>

												<div className="col-md-6 col-sm-6">
													<div className="form-group">
														<label for="tags">Tags</label>
														<input type="text" className="form-control" id="tags" name="tags" onChange={inputHandler} />
													</div>
												</div>

												<div className="col-md-6 col-sm-6">
													<div className="form-group">
														<label for="yt_video_url">Youtube Video URL Code</label>
														<input type="text" className="form-control mb-2" id="yt_video_url" name='yt_video_url' onChange={inputHandler} />
														<img src={config.baseUrl + "img/urlimg.jpg"} alt='ad-yt-video' />
													</div>
												</div>

												<div className="col-md-6 col-sm-6">
													<div className="form-group hideblock">
														<label for="formGroupExampleInput">Hide My ID</label><br />
														<input type="checkbox" id="hide_my_id" name="hide_my_id" value="1" onChange={checkboxHandler} />
													</div>
												</div>

												{/* Payment Section for Premium Plans or Ad Fees */}
												{showPaymentSection && (form.plan_id > 0 || requiresAdFeePayment) && (
													<div className="col-md-12 mt-4">
														<div className="bondiclassified-fromsection">
															<h3 className="page-heading" style={{background:headerMenuColor}}>Payment Details</h3>
															<div className="stripe-logo"><img src={config.baseUrl + "img/stripe-logo.png"} alt="stripe-logo" /></div>
															<div className="catagoryfrom">
																<div className="row">
																	<div className="col-md-12">
																		{form.plan_id > 0 ? (
																			<div className="alert alert-info">
																				<strong>Premium Plan Selected:</strong> {form.planDays} Days - ${form.planAmount}
																			</div>
																		) : requiresAdFeePayment ? (
																			<div className="alert alert-info">
																				<strong>Ad Fee Required:</strong> ${adFeeAmount} {adFeeType === 'personal_ad_fee' ? '(Personal Ad Fee)' : '(Free Ad Fee)'}
																			</div>
																		) : null}
																	</div>
																	<div className="col-md-12">
																		<div className="form-group">
																			<label htmlFor="ad-card-element">Card Details <span className='text-danger'>*</span></label>
																			<div id="ad-card-element" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff' }}>
																				{/* Stripe Card Element will be mounted here */}
																			</div>
																			<div id="ad-card-errors" role="alert" style={{ color: '#dc3545', marginTop: '5px' }}></div>
																			<p className="mt-2" style={{ fontSize: '12px', color: '#666' }}>
																				Amount: ${form.plan_id > 0 ? form.planAmount : adFeeAmount} will be charged to your card.
																			</p>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												)}

												<div className="col-md-12 text-center mt-3 pdb-20 submitsection">
													{spinloader == '0' && !paymentProcessing ? (
														<button type="submit" className="btn btn-primary submitbtn" style={{background:headerButtonColor}}>
															{form.plan_id > 0 ? `Pay $${form.planAmount || 0} & Submit` : 
															 requiresAdFeePayment ? `Pay $${adFeeAmount || 0} & Submit` : 
															 'Submit'}
														</button>
													) : (
														<button disabled className='btn btn-primary submitbtn' style={{background:headerButtonColor}}>
															{paymentProcessing ? (
																<>Processing Payment... <i className="fa fa-spinner fa-spin validat"></i></>
															) : (
																<>Submitting... <i className="fa fa-spinner fa-spin validat"></i></>
															)}
														</button>
													)}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
						<div className="col-lg-3">
							<Rightnav />
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	)

}

export default AddAd;
